import { render } from "./Editor.vue?vue&type=template&id=5b54dd3e&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=5b54dd3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b54dd3e"

export default script